import { skipToken } from '@tanstack/react-query';
import { trpc } from '@portal/trpc/client';

export const useResourceTimeSlotsQuery = (resourceId?: number) => {
  return trpc.nexudus.getResourceTimeSlots.useQuery(
    resourceId == null ? skipToken : { id: resourceId },
    {
      staleTime: 1000 * 60,
    },
  );
};
